var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container default-title__container",class:_vm.class_list},[_c(_vm.title_tag,{tag:"component",staticClass:"default-title pre_wrap",class:{upper_case: _vm.uppercase}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }